// extracted by mini-css-extract-plugin
export default {"appShell":"Layout_appShell__G3xfp","main":"Layout_main__JFLyl"};